/* eslint-disable */
export default {
  Inbound: 'Entrant',
  Outbound: 'Sortant',
  log: 'Journal',
  save: 'Enregistrer et nouveau',
  discard: 'Ignorer et nouveau',
  hangup: 'Raccrocher',
  reject: 'Vers la messagerie vocale',
  saveDraftAndCreateNewLog:
    'Enregistrer le brouillon et créer un nouveau journal d’appels',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
